import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { parseActionCodeURL } from 'firebase/auth'
import SetUpEmailForm from './components/SetUpEmailForm'
import SignInWithGoogleButton from './components/SignInWithGoogleButton'
import SetUpPasswordForm from './components/SetUpPasswordForm'
import './Login.css'
import LoginLayout from './LoginLayout'

export default function LoginPage() {
  const navigate = useNavigate()
  const [isCredentialsSetUpChosen, setIsCredentialsSetUpChosen] =
    useState(false)

  const [user, setUser] = useState()

  const verificateInviteLink = () => {
    const actionCodeURL = parseActionCodeURL(window.location.href)
    return !!actionCodeURL
  }

  useEffect(() => {
    if (!verificateInviteLink()) {
      navigate('/login')
    }
  }, [])

  const handleSetUpContinue = user => {
    setUser(user)
    setIsCredentialsSetUpChosen(true)
  }
  return (
    <LoginLayout>
      {!isCredentialsSetUpChosen ? (
        <>
          <SetUpEmailForm handleSetUpContinue={handleSetUpContinue} />
          <SignInWithGoogleButton />
        </>
      ) : (
        <SetUpPasswordForm user={user} />
      )}
    </LoginLayout>
  )
}
